// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"385":"644f92c5","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"385":"d06780dc2afd8256479f","532":"60a2bbb3aa534df17b8a","678":"6ae9940cdd60e2feb2b7","883":"902769dfb2f26c713cec"}[chunkId] + ".js";
};